document.addEventListener("DOMContentLoaded", () => {
  const secondaryNavs = document.querySelectorAll(".secondary-nav");
  const arrowIcons = document.querySelectorAll(".secondary-nav-title .arrow-icon");

  const toggleContentList = (targetLabel, navContentLists) => {
    navContentLists.forEach((item) => {
      const itemHandle = item.getAttribute("handle");
      if (itemHandle === targetLabel) {
        item.classList.remove("hide");
        item.classList.add("active");
      } else {
        item.classList.remove("active");
        item.classList.add("hide");
      }
    });
  };

  const resetAllNavActive = (item) => {
    const parentElement = item.closest(".header-nav-secondary-list");
    const currentSecondaryNavs =
      parentElement.querySelectorAll(".secondary-nav");
    currentSecondaryNavs.forEach((nav) => {
      nav.classList.remove("active");
      nav.querySelectorAll(".third-nav-title").forEach((thirdNav) => {
        thirdNav.classList.remove("active");
      });
    });
  };

  secondaryNavs.forEach((secondaryNav) => {
    const thirdNavs = secondaryNav.querySelectorAll(".third-nav-title");
    const parentBox = secondaryNav.closest(".header-nav-secondary-box");
    const navContentLists = parentBox.querySelectorAll(".nav-content-list");

    secondaryNav.addEventListener("mouseenter", function () {
      if (thirdNavs.length === 0) {
        resetAllNavActive(secondaryNav);
        secondaryNav.classList.add("active");
        const targetLabel = secondaryNav.getAttribute("aria-label");
        toggleContentList(targetLabel, navContentLists);
      } else {
        resetAllNavActive(secondaryNav);
        secondaryNav.classList.add("active");
      }
    });

    if (thirdNavs.length > 0) {
      thirdNavs.forEach((thirdNav) => {
        thirdNav.addEventListener("mouseenter", function () {
          thirdNavs.forEach((el) => el.classList.remove("active"));

          thirdNav.classList.add("active");
          const targetLabel = thirdNav.getAttribute("aria-label");
          toggleContentList(targetLabel, navContentLists);
        });
      });
    }
  });

  arrowIcons.forEach((item) => {
    item.addEventListener("click", function () {
      const parentBox = item.closest(".secondary-nav");
      const thirdNavsBox = parentBox.querySelector(".header-nav-third-list");

      if (thirdNavsBox.classList.contains("hide")) {
        thirdNavsBox.classList.remove("hide");
      } else {
        thirdNavsBox.classList.add("hide");
      }

      if (item.classList.contains("active")) {
        item.classList.remove("active");
      } else {
        item.classList.add("active");
      }
    });
  });

  // M端导航
  const mbFirstNavs = document.querySelectorAll(".drawer-nav-layout .first-nav-title",);

  mbFirstNavs.forEach((firstNav) => {
    firstNav.addEventListener("click", function () {
      mbFirstNavs.forEach((el) => el.classList.remove("active"));
      firstNav.classList.add("active");
    });
  });
});
